/**
 * 社区版 Stub:Enterprise Account API
 * ===================================
 * 原企业版的 EnterpriseAccountAPI 已随 enterprise/ 目录移除。
 * 此 stub 保留同名导出,让前端 import 能解析、Vite 能编译通过。
 * 所有方法返回安全的空 Promise(功能降级,社区版用不到这些企业功能:
 * checkout/subscription/getLimits/toggleDeletion/createTopupCheckout 都是计费订阅相关)。
 *
 * 如需恢复企业版功能,请使用官方 Chatwoot Enterprise 订阅。
 */

const noop = () => Promise.resolve({ data: {} });

class EnterpriseAccountAPIStub {
  checkout() {
    return noop();
  }

  subscription() {
    return noop();
  }

  getLimits() {
    return noop();
  }

  toggleDeletion() {
    return noop();
  }

  createTopupCheckout() {
    return noop();
  }
}

export default new EnterpriseAccountAPIStub();
